/**
 * 
 */
import Model from "@/models/Model"

export default class WhOrderer extends Model {

    //
    wh_selected_products = []

    /**
     * 
     */
    get g_state_name () {
        return this.was_processed ? "Procesada" : "Sin procesar"
    }
    
    /**
     * 
     */
    get g_supervisor_user_full_name () {
        return [
            this.g_supervisor_user.hr_employee.names,
            this.g_supervisor_user.hr_employee.last_name1,
            this.g_supervisor_user.hr_employee.last_name2,
        ].join(" ")
    }

    /**
     * 
     */
    get pch_provider_branch_offices_address () {
        return this.pch_provider_branch_offices ? this.pch_provider_branch_offices.address : "-"
    }

    /**
     * 
     */
    get pch_provider_rut () {
        return this.pch_provider ? this.pch_provider.rut : "-"
    }
    
    /**
     * 
     */
    get pch_provider_alias_name () {
        return this.pch_provider ? this.pch_provider.alias_name : "-"
    }

    /**
     * 
     */
    get wh_orderer_priority_name () {
        return this.wh_orderer_priority ? this.wh_orderer_priority.priority : "-"
    }

    /**
     * 
     */
    get wh_warehouse_name () {
        return this.wh_warehouse ? this.wh_warehouse.name : "-"
    }

    /**
     * 
     */
    static appends = [
        
    ]

    /**
     * 
     */
    static includes = [
        "g_supervisor_user.hr_employee",
        "pch_provider",
        "pch_provider_branch_offices",
        "wh_detail_orderers.wh_product",
        //"wh_detail_orderers.wh_warehouse",
        "wh_orderer_priority",
        "wh_warehouse",
    ]

    /**
     * 
     */
    mapDetail ( item ) {
        return {
            provider_product_code   : String( item.provider_product_code ),
            quantity                : Number( item.quantity ),
            wh_product_id           : Number( item.wh_product_id ),
        }
    }

    /**
     * 
     */
    mapSelected ( item ) {
        return {
            internal_code           : String( item.wh_product.internal_code ),
            id                      : Number( item.id || 0 ),
            name                    : String( item.wh_product.name ),
            provider_product_code   : String( item.provider_product_code ),
            quantity                : Number( item.quantity ),
            stock                   : Number( item.stock || 0 ),
            upc_codes               : item.wh_product.upc_codes || [],
            wh_product              : Object( item.wh_product ),
            wh_product_id           : Number( item.wh_product_id ),
        }
    }

    /**
     * 
     */
    reset () {

        //
        this.wh_selected_products = this.wh_detail_orderers.map( this.mapSelected )

        //
        return this
    }

    /**
     * 
     */
    resource () {
        return "wh_orderer"
    }

    /**
     * 
     */
    create () {

        // set detail param
        this.details = this.wh_selected_products.map( this.mapDetail )

        // update params
        var cleans = [
            "comment",
            "details",
            "g_supervisor_user_id",
            "pch_provider_id",
            "pch_provider_branch_offices_id",
            "wh_orderer_priority_id",
            "wh_warehouse_id",
        ]
        
        // post request
        return this.clean( cleans ).save()
    }

    /**
     * 
     */
    update () {

        // set detail param
        this.details = this.wh_selected_products.map( this.mapDetail )

        // update params
        var cleans = [
            "comment",
            "id",
            "details",
            "g_supervisor_user_id",
            "pch_provider_id",
            "pch_provider_branch_offices_id",
            "wh_orderer_priority_id",
            "wh_warehouse_id",
        ]
        
        // put request
        return this.clean( cleans ).save()
    }
}